export * from './virtualization';



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-data-tools/dist/es/main.js
// module id = 787
// module chunks = 93